<script lang="ts" setup>
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'

import TradingFooter from '@/components/TradingBlock/TradingFooter.vue'
import { resolveRouteName } from '@/utils/utils'
import { getEnv } from '@/utils/environmentService'
import RedirectButton from '@/components/RedirectButton/RedirectButton.vue'

let lang: string = ''

defineProps({ data: Object })

const router = useRouter()

const routeLang = computed(() => router.currentRoute.value.params.lang)
onMounted(() => {
  lang =
    localStorage.getItem('lang') !== '' &&
    localStorage.getItem('lang') !== 'undefined' &&
    localStorage.getItem('lang') !== 'en'
      ? localStorage.getItem('lang') + '/'
      : ''
})
const loginUrl = getEnv() !== 'hk' ? ('https://portal.hmarkets.' + getEnv() + '/') : 'https://portal.hmglobal.hk/'
</script>
<template>
  <div class="flex flex-col items-center lg:flex-row lg:items-start">
    <div
      class="flex flex-col md:justify-start items-center md:items-start w-full md:max-w-[346px] mt-10 md:ml-10"
    >
      <div>
        <img loading="lazy" :src="data?.logo" :alt="data?.logo_alt" />
      </div>
      <div
        class="w-full mt-5 text-base px-[10px] md:px-[0px] lg:w-[311px] lg:h-[180px] -tracking-tightest"
      >
        {{ data?.description }}
      </div>
      <div class="flex justify-center w-full lg:hidden">
        <img loading="lazy" :src="data?.main_image_mobile" :alt="data?.main_image.alt" />
      </div>
      <div class="lg:mt-5 mt-0 w-full md:px-0 px-[10px] md:max-w-[311px] d">
        <RedirectButton
          :href="
            resolveRouteName(data?.action_button_link ? data?.action_button_link : '', {
              lang: routeLang
            })
          "
          :text="data?.action_button_text"
          type="primary"
        />
        <RedirectButton
          :href="`${loginUrl}${lang === '' ? 'en/' : lang === 'zh-hans/' ? 'cns/' : lang === 'zh-hant/' ? 'cnt/' : lang}login`"
          :text="data?.secondary_button_text"
          type="secondary"
        />
      </div>
    </div>
    <div
      class="items-center justify-center hidden mt-12 lg:block lg:ml-[px] 1440:ml-[171px] min-h-[596px]"
    >
      <img loading="lazy" :src="data?.main_image" :alt="data?.main_image.alt" />
    </div>
  </div>
  <TradingFooter
    :titleOne="data?.footer_column_one_title"
    :contentOne="data?.footer_column_one_content"
    :titleTwo="data?.footer_column_two_title"
    :contentTwo="data?.footer_column_two_content"
    :titleThree="data?.footer_column_three_title"
    :contentThree="data?.footer_column_three_content"
    :titleFour="data?.footer_column_four_title"
    :contentFour="data?.footer_column_four_content"
    :footerIconLink="data?.footer_icon"
    :footerIconAlt="data?.footer_icon_alt"
    class="lg:mb-20"
  ></TradingFooter>
</template>
